module.exports = __webpack_public_path__ + "img/Weapon_55.94fa3d74.png";